import { useState } from 'react'

export const useScreeningFeedback = (screeningReportData, mentorProfileData) => {
  const [feedbackObject, setFeedbackObject] = useState({
    screeningReportId: screeningReportData?.id || '',
    doctorId: mentorProfileData?.id || '',
    qualityRating: 0,
    usefulnessRating: 0,
    completenessRating: 0,
    diagnosisAgreement: '',
    therapyRecommendationAgreement: '',
    comments: '',
  })

  const handleRatingChange = (field, value) => {
    setFeedbackObject((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleRadioChange = (field, value) => {
    setFeedbackObject((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleNotesChange = (event) => {
    setFeedbackObject((prev) => ({
      ...prev,
      comments: event.target.value,
    }))
  }

  console.log('feedbackObject', feedbackObject)

  return {
    feedbackObject,
    handleRatingChange,
    handleRadioChange,
    handleNotesChange,
  }
} 